export default "__VITE_PUBLIC_ASSET__bf2180b9__"